<template>
    <div class="">

        <div class="card">
            <div class="card-body">

            <div class="tab-danger pt-3">
                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                        <a href="#tab-detail" class="nav-link" role="tab" data-toggle="tab" aria-selected="true"
                            :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15 active show' : ''">
                            {{ label }}
                        </a>
                    </li>
                    <li v-if="this.$route.params.id" class="nav-item">
                        <a href="#tab-vacation" class="nav-link" role="tab" data-toggle="tab" aria-selected="false"
                            :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'active show'">
                            {{ $t('nav.vacations') }}
                        </a>
                    </li>
                    <li v-if="this.$route.params.id" class="nav-item">
                        <a href="#tab-absence" class="nav-link" role="tab" data-toggle="tab" aria-selected="false"
                            :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'active show'">
                            {{ $t('nav.absences') }}
                        </a>
                    </li>
                    <li v-if="this.$route.params.id" class="nav-item">
                        <a href="#tab-reward" class="nav-link" role="tab" data-toggle="tab" aria-selected="false"
                            :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'active show'">
                            {{ $t('nav.rewards') }}
                        </a>
                    </li>
                </ul>

                <div class="tab-content">
                    <div 
                        role="tabpanel" 
                        class="tab-pane fade pt-3 active show"
                        id="tab-detail">

                        <div class="row col-12">

                            <div class="form-group col-6">
                                <label 
                                    for="input1" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ $t('view.employee_category') }} 
                                </label>
                                <div class="text-center">
                                    <span 
                                        v-if="catLoading"
                                        class="spinner-grow spinner-grow-sm mr-1" 
                                        role="status" 
                                        aria-hidden="true">
                                    </span>
                                </div>
                                <select 
                                    v-if="!catLoading"
                                    id="input1"
                                    type="text" 
                                    class="form-control"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.employee_category_id" 
                                    v-on:input="onFormChange">
                                    <option 
                                        v-for="(category, idx) in categories" 
                                        :key="idx"
                                        :value="category['id']">
                                        {{ category[$i18n.locale]['title'] }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group col-6"></div>

                            <div class="form-group col-6">
                                <label 
                                    for="input1_1" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ $t('view.employee_fullName') }} 
                                </label>
                                <input 
                                    id="input1_1"
                                    type="text" 
                                    class="form-control"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.full_name" 
                                    v-on:input="onFormChange">
                            </div>

                            <div class="form-group col-6">
                                <label 
                                    for="input2_1" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ $t('view.employee_phone') }} 
                                </label>
                                <input 
                                    id="input2_1"
                                    type="text" 
                                    class="form-control"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.phone" 
                                    v-on:input="onFormChange">
                            </div>

                            <div class="form-group col-6">
                                <label 
                                    for="input2" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ $t('view.employee_jobTitle') }} 
                                </label>
                                <div class="text-center">
                                    <span 
                                        v-if="jobLoading"
                                        class="spinner-grow spinner-grow-sm mr-1" 
                                        role="status" 
                                        aria-hidden="true">
                                    </span>
                                </div>
                                <select 
                                    v-if="!jobLoading"
                                    id="input2"
                                    type="text" 
                                    class="form-control"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.job_title_id" 
                                    v-on:input="onFormChange">
                                    <option 
                                        v-for="(job, idx) in jobs" 
                                        :key="idx"
                                        :value="job['id']">
                                        {{ job[$i18n.locale]['title'] }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group col-6">
                                <label 
                                    for="input3" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ $t('view.employee_nationality') }} 
                                </label>
                                <div class="text-center">
                                    <span 
                                        v-if="natLoading"
                                        class="spinner-grow spinner-grow-sm mr-1" 
                                        role="status" 
                                        aria-hidden="true">
                                    </span>
                                </div>
                                <select 
                                    v-if="!natLoading"
                                    id="input3"
                                    type="text" 
                                    class="form-control"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.nationality_id" 
                                    v-on:input="onFormChange">
                                    <option 
                                        v-for="(nationality, idx) in nationalities" 
                                        :key="idx"
                                        :value="nationality['id']">
                                        {{ nationality[$i18n.locale]['title'] }}
                                    </option>
                                </select>
                            </div>

                            <div class="form-group col-4">
                                <label 
                                    for="input4" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ $t('view.employee_civilNo') }} 
                                </label>
                                <input 
                                    id="input4"
                                    type="text" 
                                    class="form-control"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.civil_no" 
                                    v-on:input="onFormChange">
                            </div>
                            <div class="form-group col-4">
                                <label 
                                    for="input5" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ $t('view.employee_passportNo') }} 
                                </label>
                                <input 
                                    id="input5"
                                    type="text" 
                                    class="form-control"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.passport_no" 
                                    v-on:input="onFormChange">
                            </div>
                            <div class="form-group col-4">
                                <label 
                                    for="input6" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ $t('view.employee_passportExpireDate') }} 
                                </label>
                                <input 
                                    id="input6"
                                    type="date" 
                                    class="form-control"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.passport_expire_date" 
                                    v-on:input="onFormChange">
                            </div>

                            <div class="form-group col-3">
                                <label 
                                    for="input7" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ $t('view.employee_hiringDate') }} 
                                </label>
                                <input 
                                    id="input7"
                                    type="date" 
                                    class="form-control"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.hiring_date" 
                                    v-on:input="onFormChange">
                            </div>
                            <div class="form-group col-3">
                                <label 
                                    for="input8" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ $t('view.employee_residenceExpireDte') }} 
                                </label>
                                <input 
                                    id="input8"
                                    type="date" 
                                    class="form-control"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.residence_expire_date" 
                                    v-on:input="onFormChange">
                            </div>
                            <div class="form-group col-3">
                                <label 
                                    for="input9" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ $t('view.employee_startWorkDate') }} 
                                </label>
                                <input 
                                    id="input9"
                                    type="date" 
                                    class="form-control"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.start_working_date" 
                                    v-on:input="onFormChange">
                            </div>
                            <div class="form-group col-3">
                                <label 
                                    for="input10" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ $t('view.employee_endWorkDate') }} 
                                </label>
                                <input 
                                    id="input10"
                                    type="date" 
                                    class="form-control"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.end_working_date" 
                                    v-on:input="onFormChange">
                            </div>

                            <div class="form-group col-6">
                                <label 
                                    for="input11" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ $t('view.employee_salary') }} 
                                </label>
                                <input 
                                    id="input11"
                                    type="text" 
                                    class="form-control"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.salary" 
                                    v-on:input="onFormChange">
                            </div>
                            <div class="form-group col-6">
                                <label 
                                    for="input12" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ $t('view.employee_salaryPerDay') }} 
                                </label>
                                <input 
                                    id="input12"
                                    type="text" 
                                    class="form-control"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.salary_per_day" 
                                    v-on:input="onFormChange">
                            </div>

                            <div class="form-group col-6">
                                <label 
                                    for="input13" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ $t('view.employee_bankName') }} 
                                </label>
                                <input 
                                    id="input13"
                                    type="text" 
                                    class="form-control"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.bank_name" 
                                    v-on:input="onFormChange">
                            </div>
                            <div class="form-group col-6">
                                <label 
                                    for="input14" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ $t('view.employee_bankIBAN') }} 
                                </label>
                                <input 
                                    id="input14"
                                    type="text" 
                                    class="form-control"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.bank_iban_no" 
                                    v-on:input="onFormChange">
                            </div>

                            <div class="form-group col-4">
                                <label 
                                    for="input15" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ $t('view.employee_bankBranchName') }} 
                                </label>
                                <input 
                                    id="input15"
                                    type="text" 
                                    class="form-control"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.bank_branch_name" 
                                    v-on:input="onFormChange">
                            </div>
                            <div class="form-group col-4">
                                <label 
                                    for="input16" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ $t('view.employee_bankCreditNo') }} 
                                </label>
                                <input 
                                    id="input16"
                                    type="text" 
                                    class="form-control"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.bank_credit_no" 
                                    v-on:input="onFormChange">
                            </div>
                            <div class="form-group col-4">
                                <label 
                                    for="input17" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ $t('view.employee_bankPassword') }} 
                                </label>
                                <input 
                                    id="input17"
                                    type="text" 
                                    class="form-control"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.bank_password" 
                                    v-on:input="onFormChange">
                            </div>

                            <div class="form-group col-6">
                                <label 
                                    for="input18" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ $t('view.employee_licenseNo') }} 
                                </label>
                                <input 
                                    id="input18"
                                    type="text" 
                                    class="form-control"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.license_no" 
                                    v-on:input="onFormChange">
                            </div>
                            <div class="form-group col-6">
                                <label 
                                    for="input19" 
                                    class="col-form-label"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : 'float-left'">
                                    {{ $t('view.employee_licenseExpireDate') }} 
                                </label>
                                <input 
                                    id="input19"
                                    type="date" 
                                    class="form-control"
                                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                                    v-model="row.license_expire_date" 
                                    v-on:input="onFormChange">
                            </div>

                        </div>
                    </div>

                    <div 
                        role="tabpanel" 
                        class="tab-pane fade pt-3"
                        id="tab-vacation">

                        <div class="col-12" style="padding:0">
                            <MinTable
                                :title="$t('view.vacation_name')"
                                :refs="'vacations'">
                            </MinTable>
                        </div>
                    </div>

                    <div 
                        role="tabpanel" 
                        class="tab-pane fade pt-3"
                        id="tab-absence">

                        <div class="col-12" style="padding:0">
                            <MinTable
                                :title="$t('view.absence_name')"
                                :refs="'absences'">
                            </MinTable>
                        </div>
                    </div>

                    <div 
                        role="tabpanel" 
                        class="tab-pane fade pt-3"
                        id="tab-reward">

                        <div class="col-12" style="padding:0">
                            <MinTable
                                :title="$t('view.reward_name')"
                                :refs="'rewards'">
                            </MinTable>
                        </div>
                    </div>

                </div>

                </div>

            </div>
        </div>
         
    </div>
</template>

<script>
import iziToast from 'izitoast';

export default {
    namme: 'FormElements',
    components: {
        MinTable: () => import('@/views/employees/MinTable.vue'),
    },
    props: [
        'label',
        'full_name',
        'employee_category_id',
        'job_title_id',
        'nationality_id',
        'civil_no',
        'passport_no',
        'passport_expire_date',
        'hiring_date',
        'residence_expire_date',
        'start_working_date',
        'end_working_date',
        'salary',
        'salary_per_day',
        'bank_iban_no',
        'bank_name',
        'bank_branch_name',
        'bank_credit_no',
        'bank_password',
        'license_no',
        'license_expire_date',
    ],
    data() {
        return {
            auth: {
                access_token: ''
            },

            row: {
                full_name: this.$props.full_name,
                employee_category_id: this.$props.employee_category_id,
                job_title_id: this.$props.job_title_id,
                phone: this.$props.phone,
                nationality_id: this.$props.nationality_id,
                civil_no: this.$props.civil_no,
                passport_no: this.$props.passport_no,
                passport_expire_date: this.$props.passport_expire_date,
                hiring_date: this.$props.hiring_date,
                residence_expire_date: this.$props.residence_expire_date,
                start_working_date: this.$props.start_working_date,
                end_working_date: this.$props.end_working_date,
                salary: this.$props.salary,
                salary_per_day: this.$props.salary_per_day,
                bank_iban_no: this.$props.bank_iban_no,
                bank_name: this.$props.bank_name,
                bank_branch_name: this.$props.bank_branch_name,
                bank_credit_no: this.$props.bank_credit_no,
                bank_password: this.$props.bank_password,
                license_no: this.$props.license_no,
                license_expire_date: this.$props.license_expire_date,
            },

            catLoading: true,
            jobLoading: true,
            natLoading: true,

            categories: [],
            jobs: [],
            nationalities: [],

            editor: {
                api_key: window.editor_apiKey,
                menubar: window.editor_menubar,
                plugins: window.editor_plugins,
                toolbar: window.editor_toolbar,
            },
        }
    },
    mounted() {},
    created() {
        //
        if(localStorage.getItem('access_token')) {
            this.auth.access_token = localStorage.getItem('access_token');
        }

        this.fetchEmployeeCategories();
        this.fetchJobTitles();
        this.fetchNationalties();
    },
    methods: {
        onFormChange(){
            const data = {
                full_name: this.row.full_name,
                employee_category_id: this.row.employee_category_id,
                phone: this.row.phone,
                job_title_id: this.row.job_title_id,
                nationality_id: this.row.nationality_id,
                civil_no: this.row.civil_no,
                passport_no: this.row.passport_no,
                passport_expire_date: this.row.passport_expire_date,
                hiring_date: this.row.hiring_date,
                residence_expire_date: this.row.residence_expire_date,
                start_working_date: this.row.start_working_date,
                end_working_date: this.row.end_working_date,
                salary: this.row.salary,
                salary_per_day: this.row.salary_per_day,
                bank_iban_no: this.row.bank_iban_no,
                bank_name: this.row.bank_name,
                bank_branch_name: this.row.bank_branch_name,
                bank_credit_no: this.row.bank_credit_no,
                bank_password: this.row.bank_password,
                license_no: this.row.license_no,
                license_expire_date: this.row.license_expire_date
            }
            this.$emit('formChange', data)
        },

        fetchEmployeeCategories() {
            this.catLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                'Authorization': `Bearer ` + this.auth.access_token,
            };
            const options = {
                url: window.baseURL+'/settings/employeecategories',
                method: 'GET',
                data: {},
                params: {
                    status: 'active',
                    paginate: 1000
                }
            }
            this.axios(options)
            .then(res => {
                this.catLoading = false;
                this.categories = res.data.row.childs;
            })
            .catch(err => {
                this.catLoading = false;
                iziToast.warning({
                    icon: 'bx bx-angry',
                    title: '',
                    message: (err.response) ? err.response.data.message : ''+err
                });
            })
        },

        fetchJobTitles() {
            this.jobLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                'Authorization': `Bearer ` + this.auth.access_token,
            };
            const options = {
                url: window.baseURL+'/settings/jobtitles',
                method: 'GET',
                data: {},
                params: {
                    status: 'active',
                    paginate: 1000
                }
            }
            this.axios(options)
            .then(res => {
                this.jobLoading = false;
                this.jobs = res.data.row.childs;
            })
            .catch(err => {
                this.jobLoading = false;
                iziToast.warning({
                    icon: 'bx bx-angry',
                    title: '',
                    message: (err.response) ? err.response.data.message : ''+err
                });
            })
        },

        fetchNationalties() {
            this.natLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                'Authorization': `Bearer ` + this.auth.access_token,
            };
            const options = {
                url: window.baseURL+'/settings/nationalities',
                method: 'GET',
                data: {},
                params: {
                    status: 'active',
                    paginate: 1000
                }
            }
            this.axios(options)
            .then(res => {
                this.natLoading = false;
                this.nationalities = res.data.row.childs;
            })
            .catch(err => {
                this.natLoading = false;
                iziToast.warning({
                    icon: 'bx bx-angry',
                    title: '',
                    message: (err.response) ? err.response.data.message : ''+err
                });
            })
        },
    }
}
</script>

<style scoped="">
    input[type=date] {
        padding: 5px;
    }
</style>
